import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminPromotionsService } from '../../core/services/admin-promotions.service';
import { AdminPromotion } from '../../core/models/admin.models';
import { ModalComponent } from '../../shared/components/ui/modal/modal.component';
import { PromotionFormComponent } from '../promotion-form/promotion-form.component';

@Component({
  selector: 'app-promotions-list',
  standalone: true,
  imports: [CommonModule, ModalComponent, PromotionFormComponent],
  templateUrl: './promotions-list.component.html'
})
export class PromotionsListComponent implements OnInit {

  promotions: AdminPromotion[] = [];
  isLoading = false;
  errorMessage = '';

  isModalOpen = false;
  selectedPromotion: AdminPromotion | null = null;

  constructor(private promotionsService: AdminPromotionsService) {}

  ngOnInit() {
    this.loadPromotions();
  }

  loadPromotions() {
    this.isLoading = true;
    this.errorMessage = '';
    
    this.promotionsService.getPromotions().subscribe({
      next: (res) => {
        this.promotions = Array.isArray(res) ? res : (res as any).data ?? [];
        this.isLoading = false;
      },
      error: (err) => {
        this.errorMessage = err?.error?.message ?? 'Failed to load promotions.';
        this.isLoading = false;
      }
    });
  }

  openCreateModal() {
    this.selectedPromotion = null;
    this.isModalOpen = true;
  }

  openEditModal(promo: AdminPromotion) {
    this.selectedPromotion = promo;
    this.isModalOpen = true;
  }

  handleSave(data: Partial<AdminPromotion>) {
    const action$ = this.selectedPromotion 
        ? this.promotionsService.updatePromotion(this.selectedPromotion.id, data)
        : this.promotionsService.createPromotion(data);

    action$.subscribe({
      next: () => {
        this.isModalOpen = false;
        this.loadPromotions();
      },
      error: (err) => alert(err?.error?.message ?? 'Action failed.')
    });
  }

  deletePromotion(id: number) {
    if(confirm('Are you sure you want to delete this promotion?')) {
      this.promotionsService.deletePromotion(id).subscribe({
        next: () => this.loadPromotions(),
        error: (err) => alert(err?.error?.message ?? 'Failed to delete promotion.')
      });
    }
  }

  isExpired(endDate: string | undefined): boolean {
    if (!endDate) return false;
    return new Date(endDate) < new Date();
  }
}
